import React from 'react';
import PropTypes from 'prop-types';

import styles from './savedListModalActions.scss';

const CANCEL_LABEL = 'Cancel';
const SAVE_LABEL = 'Save';
const DEFAULT_CANCEL_TESTID_SUFFIX = 'cancel-btn';
const DEFAULT_PRIMARY_TESTID_SUFFIX = 'save-btn';

// Shared Cancel/primary footer for the SavedLists modals (SaveToListModal, CreateListModal, and the
// AddPlayerToListModal wizard's Step 1 "Next" / Step 2 "Save"). The caller passes its own
// `data-testid` prefix; the exact per-modal suffixes are overridable so the wizard can keep its
// `.cancel` / `.next` / `.save` contract while the sibling modals keep `.cancel-btn` / `.save-btn`.
const SavedListModalActions = ({
    'data-testid': dataTestId,
    onCancel,
    onSave,
    saveDisabled,
    saveLabel,
    cancelTestidSuffix,
    primaryTestidSuffix,
    pinned,
}) => (
    <div
        className={`${styles.actions} ${pinned ? styles.actionsPinned : ''}`}
        data-testid={dataTestId && `${dataTestId}.actions`}
    >
        <button
            type="button"
            className={styles.cancelBtn}
            onClick={onCancel}
            data-testid={dataTestId && `${dataTestId}.${cancelTestidSuffix}`}
        >
            {CANCEL_LABEL}
        </button>
        <button
            type="button"
            className={styles.saveBtn}
            disabled={saveDisabled}
            onClick={onSave}
            data-testid={dataTestId && `${dataTestId}.${primaryTestidSuffix}`}
        >
            {saveLabel}
        </button>
    </div>
);

SavedListModalActions.propTypes = {
    'data-testid': PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    saveDisabled: PropTypes.bool,
    saveLabel: PropTypes.string,
    cancelTestidSuffix: PropTypes.string,
    primaryTestidSuffix: PropTypes.string,
    pinned: PropTypes.bool,
};

SavedListModalActions.defaultProps = {
    'data-testid': null,
    saveDisabled: false,
    saveLabel: SAVE_LABEL,
    cancelTestidSuffix: DEFAULT_CANCEL_TESTID_SUFFIX,
    primaryTestidSuffix: DEFAULT_PRIMARY_TESTID_SUFFIX,
    pinned: false,
};

export default SavedListModalActions;
